import TrackingService from "@services/tracking/tracking.service";
import { EventTypes } from "@services/tracking/types/eventTypes";

import { getProductTrackingInfo } from "@factory/Tracking/product.model";

import { TypedAnalyticsEvent } from "../types/analyticsEvent";
import { ProductImpressionTrackingInfo } from "../types/trackingInfo/productImpressionTrackingInfo";
import { ProductImpressionModel } from "../types/trackingInfo/productImpressionmodel";
import { getPageInfo, getUserInfo } from "./pageImpressionTracker";
import { getEventName, getJsonPayload } from "./utils";

const trackProductImpressionFromNode = (element: HTMLElement) => {
    const aemModel: ProductImpressionModel = getJsonPayload(
        element,
        "ecommerceModel",
    );
    const eventName = getEventName(element);
    trackProductImpression(getProductTrackingInfo(aemModel), eventName);
};

const trackProductImpressionFromJson = (
    productJson: ProductImpressionModel,
    list?: string,
    placement?: number,
) => {
    trackProductImpression(
        getProductTrackingInfo(productJson, list, placement),
    );
};

const trackProductClickImpressionFromJson = (
    productJson: ProductImpressionModel,
    list?: string,
    placement?: number,
) => {
    trackProductImpression(
        getProductTrackingInfo(productJson, list, placement),
        EventTypes.ProductClickImpression,
    );
};

const trackProductImpression = (
    productImpressionTrackingInfo: ProductImpressionTrackingInfo,
    eventName: string = EventTypes.ProductImpression,
): void => {
    const event: TypedAnalyticsEvent<ProductImpressionTrackingInfo> = {
        event: eventName,
        payload: {
            eventData: productImpressionTrackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export {
    trackProductImpression,
    trackProductImpressionFromNode,
    trackProductImpressionFromJson,
    trackProductClickImpressionFromJson,
};
